
import { VTabsItems } from "vuetify/lib";

export default VTabsItems.extend({});
